import { Box } from '@chakra-ui/react';
import type { SpacerBlock as SpacerBlockType } from '../../editor/types';
import { useResponsiveValue } from '../PreviewDeviceContext';
import { BLOCK_PADDING_VALUES } from '../../editor/constants/blockLayoutDefaults';

type SpacerBlockProps = SpacerBlockType['props'];

export function SpacerBlock({ height, mobile_height }: SpacerBlockProps): React.ReactElement {
  const effectiveHeight = useResponsiveValue(
    BLOCK_PADDING_VALUES[mobile_height ?? height] ?? '0',
    BLOCK_PADDING_VALUES[height] ?? '0',
  );

  return <Box gc-testing-id="blockSpacer" h={effectiveHeight} />;
}
